import { feeds } from "../../apis/services";
import { FETCH_MASTER_MANIFEST } from "../../constants/masterManifest";

export const fetchMasterManifest = (params) => ({
  type: FETCH_MASTER_MANIFEST,
  payload: feeds.getMasterManifest(params),
});
